import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

const StyledVisaBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.baseWhite};
  border: 1px solid ${({ theme }) => theme.colors.base3};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};
  box-shadow: ${({ theme }) => theme.shadows.card};

  > img {
    margin-bottom: 12px;
  }

  .visa-banner-cta-arrow {
    display: none;
  }

  /* matches the "Scan document..." heading right next to this card
     (AutomatedTools-IBEROJET.styled.ts), which overrides Summary the same way */
  ${Summary} {
    font-weight: 600;
  }

  ${SmallPrint} {
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #6e6c6d;
  }

  ${ButtonTitle} {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.link};
    text-decoration: ${({ theme }) =>
      theme.linkUnderlined ? "underline" : "none"};
  }
`;

export default StyledVisaBanner;
